export default __webpack_public_path__ + "static/media/abdm.9028c2d6.jpeg";